"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'autoplay',
    'controls',
    'controlsList',
    'loop',
    'muted',
    'preload',
    'src',
]);
//# sourceMappingURL=audio.js.map